import { useContext } from 'react';
import { useAuth, useOrganization } from '@clerk/clerk-react';
import { ActiveOrgContext } from '../modules/App/activeOrgContext';

// Single source of truth for route org readiness.
// Permission readiness is owned by PermissionRoute/AdminGuard.
//
// Prefers the authoritative active org published by OrgBoundary
// (ActiveOrgContext) over Clerk's `useOrganization()` hook: the hook lags a
// same-session `setActive()` switch, and reading it here bounced type-changing
// org switches (operator↔declarant) to /not-found (the destination overview's
// org-type gate saw the stale, previous org type). Falls back to the hook when
// rendered outside a provider (unit tests, out-of-boundary usage).
export const useAuthReadiness = () => {
  const active = useContext(ActiveOrgContext);
  const { isLoaded: orgLoaded, organization: hookOrg } = useOrganization();
  const { isLoaded: authLoaded } = useAuth();

  const source = active ?? { isLoaded: orgLoaded, organization: hookOrg };

  if (!authLoaded || !source.isLoaded) return { status: 'loading', organization: null };
  if (source.organization === undefined) return { status: 'loading', organization: null };
  if (source.organization === null) return { status: 'no-org', organization: null };
  return { status: 'ready', organization: source.organization };
};
